export function addCurrent(distributionstrategy) {
    return {
        type: 'ADD_CURRENT',
        distributionstrategy,
    }
}
